export default __webpack_public_path__ + "static/media/remove.bb499c70.svg";